<template>
  <div class="content">
    <div class="tab-box">
      <div class="tab-left">
        <span class="item left" :class="{active: currentTab == 1}" @click="changeTab(1)">微信对账</span>
        <span class="item" :class="{active: currentTab == 2}" @click="changeTab(2)">银联对账</span>
      </div>
      <div class="tab-right">
        <div class="input-box" @click="isShowCalender = true">
          <span>{{ date }}</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="rest" v-if="currentTab == 2" @click="restDate">重置</div>
      </div>
    </div>
    <weChat-checking 
      ref="weChatRef"
      :dateParmes="dateParmes"
      v-if="currentTab == 1"
    />
    <unionpay-checking 
      ref="unionpayRef"
      :dateParmes="dateParmes"
      :customerMerNoList="customerMerNoList"
      v-if="currentTab == 2"
    />
    <van-calendar 
      v-model="isShowCalender" 
      type="range" 
      @confirm="onConfirm"
      color="#FF6B31" 
      max-range="360"
     :min-date="minDate" 
     :max-date="maxDate"
     :default-date="defaultDate"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import weChatChecking from './componets/weChat-checking.vue';
  import unionpayChecking from './componets/unionpay-checking.vue';
  export default {
    components: {
      weChatChecking,
      unionpayChecking
    },
    data() {
      return {
        currentTab: 1,
        isShowCalender: false,
        minDate:  moment('2022-01-01').toDate(),
        maxDate: new Date(),
        defaultDate: [],
        date: '',
        dateParmes: {},
        customerMerNoList: []
      }
    },
    created() {
      this.queryCustomerMerNoList()
      this.currentTab = this.$route.query.type || 1
      this.initDate()
    },
    methods: {
      initDate() {
        if (this.currentTab == 1) {
          let startDate = moment().subtract(1, 'month').toDate()
          let endDate = moment().toDate()

          this.defaultDate = [startDate,endDate]
          this.date = `${moment(startDate).format('MM/DD')}-${moment(endDate).format('MM/DD')}`

          this.dateParmes = { 
            startDate: moment(startDate).format('YYYYMMDD'),
            endDate: moment(endDate).format('YYYYMMDD'),
          }
        } else {
          this.dateParmes = {}
          this.defaultDate = null
          this.date = ''
        }
      },
      queryCustomerMerNoList() {
        this.$api.withdrawal.queryCustomerMerNoList()
          .then(res => {
            if (res.data && res.data.length) {
              this.customerMerNoList = res.data
            }
          })
      },
      changeTab(type) {
        this.currentTab = type
        this.initDate()
      },
      onConfirm(rangeTime) {
        const [startDate, endDate] = rangeTime;
         this.date = `${moment(startDate).format('MM/DD')}-${moment(endDate).format('MM/DD')}`
        this.dateParmes= { 
          startDate: moment(startDate).format('YYYYMMDD'),
          endDate: moment(endDate).format('YYYYMMDD'),
        }
        this.isShowCalender = false
        if (this.currentTab == 1) {
          this.$refs.weChatRef.dateSearch()
        } else {
          this.$refs.unionpayRef.dateSearch()
        }
      },
      restDate() {
        this.dateParmes = {}
        this.date = ''
        this.defaultDate = []
        this.$refs.unionpayRef.dateSearch()
      }
    }
  }
</script>

<style lang="stylus" scoped>
.content {
  background: #fff;
  .tab-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 15px;
    padding-top: 15px;
    
    .tab-left {
      display: flex;
      color: 15px;
      .item {
        margin-right: 30px;
        padding-bottom: 5px;
      }
      .active {
        color: #FF6B31;
        border-bottom: 2px solid #FF6B31;
      }
    }
    .tab-right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .input-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 90px;
        height: 26px;
        padding: 0 6px;
        background: #EEEEEE;
        border-radius: 13px;
        color: #666666;
      }
      .rest {
        margin-left: 6px;
      }
    }
  }
}
</style>